if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();

        // --- Main product ID ---
        const mainProductInput = this.form.querySelector('input[name="id"]');
        const mainProductId = mainProductInput ? mainProductInput.value : null;

        // --- Collect preview uploads (enhanced logic) ---
        const allPreviewItems = document.querySelectorAll(
          '.charms-preview-container .upload__preview-item'
        );

        const productMap = {}; 

        allPreviewItems.forEach((item) => {
          const productId = item.getAttribute('data-id');
          const imgInput = item.querySelector('input[type="hidden"]');
          if (!imgInput || !imgInput.value) return;

          const imageURL = imgInput.value;

          if (!productMap[productId]) productMap[productId] = [];

          // Check if same image already exists for this product
          const existingItem = productMap[productId].find(
            (entry) => entry.image === imageURL
          );

          if (existingItem) {
            // Same image found → increase quantity
            existingItem.quantity += 1;
          } else {
            // Different image or new product → add new entry
            productMap[productId].push({
              image: imageURL,
              quantity: 1,
            });
          }
        });

        // --- Collect charms preview items ---
        const charmsItems = document.querySelectorAll(
          '.charms-preview-container .charms-preview-item'
        );

        const charmsList = [];
        charmsItems.forEach((item) => {
          const charmId = item.getAttribute('data-id');
          const engravingText = item.getAttribute('engraving-text');
          const charmType = item.getAttribute('data-type');

          // push all charms to list with type + engraving if exists
          charmsList.push({
            id: charmId,
            engraving: engravingText,
            type: charmType,
          });
        });

        // --- Collect selected bundle variants ---
        const checkedRadioButton = document.querySelector(
          'input[name="bundle_product"]:checked'
        );
        const checkedRadioButton_a = document.querySelector(
          'input[name="bundle_product_second"]:checked'
        );
        const checkedRadioButton_b = document.querySelector(
          'input[name="bundle_product_third"]:checked'
        );

        const selectedVariants = [];
        if (checkedRadioButton)
          selectedVariants.push(checkedRadioButton.getAttribute('selected_var'));
        if (checkedRadioButton_a)
          selectedVariants.push(
            checkedRadioButton_a.getAttribute('selected_var')
          );
        if (checkedRadioButton_b)
          selectedVariants.push(
            checkedRadioButton_b.getAttribute('selected_var')
          );

        // --- Merge all products ---
        const uniqueProductIds = new Set([
          ...selectedVariants,
          ...Object.keys(productMap),
        ]);
        if (mainProductId) uniqueProductIds.add(mainProductId);

        let index = 0;

        // --- Add main + bundle + preview upload items ---
        uniqueProductIds.forEach((productId) => {
          if (productMap[productId]) {
            // If product has preview images, handle each individually
            productMap[productId].forEach((entry) => {
            // const photoLabel = {{ settings.dein_foto_label | json }};
              formData.append(`items[${index}][id]`, productId);
              formData.append(`items[${index}][quantity]`, entry.quantity);
            //   formData.append(`items[${index}][properties][Your Photo]`, entry.image);
            formData.append(`items[${index}][properties][Tu Foto]`, entry.image);
              index++;
            });
          } else {
            // Normal product (without preview images)
            formData.append(`items[${index}][id]`, productId);
            formData.append(`items[${index}][quantity]`, 1);
            index++;
          }
        });

        // --- Add charms items ---
        charmsList.forEach((charm) => {
          formData.append(`items[${index}][id]`, charm.id);
          formData.append(`items[${index}][quantity]`, 1);

          // Add engraving property only if available
          if (charm.engraving && charm.engraving.trim() !== '') {
            formData.append(
              `items[${index}][properties][Engraving]`,
              charm.engraving
            );
          }

          index++;
        });

        // --- Cart section handling ---
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        // --- Add to cart fetch ---
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(
                '.sold-out-message'
              );
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    countdown('ten-countdown', 10, 0);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              countdown('ten-countdown', 10, 0);
            }
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
